import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'
import { useLayoutEffect } from 'react'

export const usePxtorem = () => {
  const device = useResponsiveDevice()

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return

    const setRemUnit = () => {
      const docEl = document.documentElement
      const rem = docEl.clientWidth / 10
      docEl.style.fontSize = rem + 'px'
    }

    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        setRemUnit()
      }
    }

    if (device === 'phone') {
      ;(function flexible(window, document) {
        const docEl = document.documentElement
        const dpr = window.devicePixelRatio || 1

        // function setBodyFontSize() {
        //   if (document.body) {
        //     document.body.style.fontSize = 12 * dpr + 'px'
        //   } else {
        //     document.addEventListener('DOMContentLoaded', setBodyFontSize)
        //   }
        // }
        // setBodyFontSize()

        setRemUnit()

        window.addEventListener('resize', setRemUnit)
        window.addEventListener('pageshow', handlePageShow)

        if (dpr >= 2) {
          const fakeBody = document.createElement('body')
          const testElement = document.createElement('div')
          testElement.style.border = '.5px solid transparent'
          fakeBody.appendChild(testElement)
          docEl.appendChild(fakeBody)
          if (testElement.offsetHeight === 1) {
            docEl.classList.add('hairlines')
          }
          docEl.removeChild(fakeBody)
        }
      })(window, document)
    } else {
      window.removeEventListener('resize', setRemUnit)
      window.removeEventListener('pageshow', handlePageShow)

      document.documentElement.style.fontSize = '37.5px'

      if (document.body) {
        document.body.style.fontSize = ''
      }

      document.documentElement.classList.remove('hairlines')
    }

    return () => {
      window.removeEventListener('resize', setRemUnit)
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [device])
}
